import React from 'react';

const TermsOfService = () => {
  return (
    <div className="flex justify-center bg-gray-100 py-8 px-4 font-['Poppins']">
      <div className="w-full max-w-4xl">
        <h1 className="text-center text-xl font-medium text-[#53686A] mb-6">Terms of Services</h1>
        
        <div className="bg-white p-6 md:p-8 border border-black">
          <div className="mb-6">
            <p className="text-sm md:text-base text-gray-800 leading-relaxed">
              Welcome to Hellocer, this online platform connects clients worldwide. These Terms of Services outline the 
              agreement between Hellocer and users like you, control your use of our platform.
            </p>
          </div>

          <div className="mb-6">
            <p className="text-sm md:text-base text-gray-800 leading-relaxed">
              By accessing or using Hellocer, you agree to abide by these Terms. Please read them carefully before using this 
              website. By accessing or using any part of the services, it means you agree to the terms, you may not have access 
              to the Services of this website if you do not agree to the conditions of the agreement.
            </p>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">1. User Accounts</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">1.1.</span> In order to access certain features of the Services, you may be required to create an account. When 
                  creating an account, you agree to provide accurate, current, and complete information during registration.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">1.2.</span> You are solely responsible for maintaining the confidentiality of your account and password. You agree to 
                  accept responsibility for all activities that occur under your account.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">2. Job Posting</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">2.1.</span> Employers and clients may post job listings on our platform. By posting a job listing, you represent and 
                  warrant that the information provided is accurate and not misleading.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">2.2.</span> We reserve the right to remove any job postings that violate these Terms or are otherwise inappropriate, 
                  in our sole discretion.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">3. Job Application</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">3.1.</span> Job seekers may apply for jobs posted on our platform. By submitting an application, you agree to 
                  allow the employer to access your application materials.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">3.2.</span> We guarantee that you will be contacted by any employer or receive any job offer as a result of 
                  using our Services.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">4. Prohibited Conduct</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">4.1.</span> You agree not to use the Services for any unlawful purpose or in any way that violates these Terms.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">4.2.</span> Prohibited conduct includes, but is not limited to, the following:
                </p>
                <ul className="list-disc pl-8 mt-2 space-y-1">
                  <li className="text-sm md:text-base text-gray-800">Posting inaccurate, misleading, or fraudulent information.</li>
                  <li className="text-sm md:text-base text-gray-800">Impersonating another person or entity.</li>
                  <li className="text-sm md:text-base text-gray-800">Attempting to gain unauthorized access to our systems or networks.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">5. Intellectual Property</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">5.1.</span> All content included in the Services, including text, graphics, logos, and images, is the property of Hellocer
                  or its licensors and is protected by copyright and other laws.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">5.2.</span> You may not reproduce, modify, distribute, or otherwise use any content from the Services without our 
                  prior written consent.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">6. Limitation of Liability</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">6.1.</span> Hellocer shall not be liable for any indirect, consequential damages, or any loss of profits, whether incurred
                  directly or indirectly or any loss of data and other intangible losses, resulting from your conduct or content of
                  any third party on the Services.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">7. Changes to Terms</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">7.1.</span> We have the right to modify these Terms at any time. If we make changes, we will notify you by posting the
                  revised Terms on the website.
                </p>
              </div>
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">7.2.</span> By continuing accessing or use the Services after any change of terms become effective, you agree to be
                  bound by the revised Terms. If you do not agree to the new Terms, you will not be able to use the Services.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">8. Governing Law</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">8.1.</span> These Terms shall be governed by and construed in accordance with the laws, without regard to its conflict
                  of law provisions.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <h2 className="font-medium text-sm md:text-base">9. Contact Us</h2>
            <div className="ml-4 md:ml-6 space-y-3 mt-2">
              <div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  <span className="mr-1">9.1.</span> If you have any questions about these Terms, please contact us at Hellocer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;